import { FormControl } from "@angular/forms";
import { AssessmentPdfGenerator } from "src/app/patients/dashboard-page/assessments-history-tab/assessment-to-pdf";

export const noString = 'N/A'; // the default string to use if no value is provided for string variables

export type ControlsOf<T> = {
  [K in keyof T]: FormControl<T[K] | null>;
};

export interface AssessmentHelpers {
  createFormGroup: (assessment?: any) => any;
  toPDF: (pdf: AssessmentPdfGenerator, assessment: any, extra?: any) => void;
  formToObject: (fg: any) => any;
  initialState: {
    [key: string]: any;
  };
}